import editForm from "formiojs/components/number/Number.form" // Number form extends textfield anyway

export default function(...extend) {
    return editForm([
        {
            key: 'conditional',
            ignore: true
        },
        {
            key: 'addons',
            ignore: true
        },
        {
            key: 'display',
            components: [
                {
                    key: 'labelPosition',
                    ignore: true
                },
                {
                    key: 'description',
                    ignore: true
                },
                {
                    key: 'hideLabel',
                    ignore: true
                },
                {
                    key: 'autofocus',
                    ignore: true
                },
                {
                    key: 'tooltip',
                    ignore: true
                },
                {
                    key: 'tabindex',
                    ignore: true
                },
                {
                    key: 'disabled',
                    ignore: true
                },
                {
                    key: 'displayMask',
                    ignore: true
                },
                {
                    key: 'prefix',
                    ignore: true
                },
                {
                    key: 'suffix',
                    ignore: true
                },
                {
                    key: 'autocomplete',
                    ignore: true
                },

            ]
        },
        {
            key: 'data',
            components: [
                {
                    key: 'multiple',
                    ignore: true
                },
                {
                    key: 'truncateMultipleSpaces',
                    ignore: true
                },
                {
                    key: 'delimiter',
                    ignore: true
                },
                {
                    key: 'decimalLimit',
                    ignore: true
                },
                {
                    key: 'requireDecimal',
                    ignore: true
                },
                {
                    key: 'clearOnHide',
                    ignore: true,
                    defaultValue: false
                },
                {
                    type: 'selectdropdown',
                    label: 'Components to Sum',
                    key: 'sumComponents',
                    input: true,
                    multiple: true,
                    tooltip: 'Select the number or currency components whose values you wish to total. Empty components are treated as 0. The value of this component will update with the selected components, always producing an accurate sum.',
                    dataSrc: 'values',
                    data: {
                        values: [
                            // populated in Sum.js
                        ]
                    },
                    weight: 1
                },
            ]
        },
    ], ...extend);
}
